import { components } from "@libertify/api-types/media";
import {
  FaceProfileResponse,
  VoiceProfileResponse,
  FaceProfileCreationResponse as _FaceProfileCreationResponse,
} from "pages/media/types";
import { Dispatch, MutableRefObject, SetStateAction } from "react";
import { AvatarCloneModalType } from "./AvatarCloneVoiceAndFaceModal";

export type PremadeVoiceLanguageFilterEntry =
  components["schemas"]["PremadeVoiceLanguageFilterEntry"];

export type VoiceAndFaceContainerProps = {
  setSelectedVoice?: (voice: VoiceProfileResponse | undefined) => void;
  setSelectedFace?: (face: FaceProfileResponse) => void;
  selectedFace?: Partial<FaceProfileResponse>;
  selectedVoice?: VoiceProfileResponse;
  setCurrentModal: (modal: AvatarCloneModalType) => void;
  disableFace?: (value: boolean) => void;
  style?: React.CSSProperties;
  clonedVoice?: VoiceProfileResponse;
  clonedFace?: FaceProfileResponse;
  setClonedFace?: Dispatch<
    SetStateAction<FaceProfileCreationResponse | undefined>
  >;
  setClonedVoice?: Dispatch<SetStateAction<VoiceProfileResponse | undefined>>;
  cloneVoiceResponse?: VoiceProfileResponse;
  cloneFaceResponse?: FaceProfileCreationResponse;
  voiceOnly?: boolean;
  initialTab?: "1" | "2";
  closeModalCallback?: MutableRefObject<
    (newFace: Partial<FaceProfileResponse>) => void
  >;
  scriptLanguage?: string;
  isLoadingExistingContact: boolean;
  isNewAvatar?: boolean;
};

export type VoiceFilterOptions = Record<string, string[]>;

/** Language code only (max one); sent as `languages` query param. */
export const VOICE_LANGUAGE_FILTER_KEY = "language";

/** Accent for selected language (max one); merged into `languages` query param. */
export const VOICE_ACCENT_FILTER_KEY = "accent";

/** Locales for selected language (multi); fanned out into `languages` query param. */
export const VOICE_LOCALE_FILTER_KEY = "locale";
export enum ActiveTabName {
  Loading = "Loading",
  Premade = "Premade",
  Custom = "Custom",
}
export type FaceProfileCreationResponse = _FaceProfileCreationResponse & {
  id: string;
  category: FaceProfileResponse["category"];
};
